import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OL_COLOUR_BLACK_90 } from 'src/web/components/Style/colours';

export const OptionWrapper = styled('div')(
  ({ isSelected }: { isSelected: boolean }) => ({
    background: isSelected ? 'red' : 'transparent',
  })
);

export const StyledDropdownIcon = styled(FontAwesomeIcon)({
  color: OL_COLOUR_BLACK_90,
});
